import React, { useEffect } from "react";

/** Sets the browser tab title as "Synod Link — {title}". */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title ? `Synod Link — ${title}` : "Synod Link";
    return () => {
      document.title = "Synod Link";
    };
  }, [title]);
}

interface PageHeaderProps {
  title: string;
  /** One line of context shown under the title. */
  subtitle?: string;
  /** Actions rendered on the right-hand side of the header row. */
  children?: React.ReactNode;
}

/** Standard page header: serif title, optional subtitle, actions on the right. */
function PageHeader({ title, subtitle, children }: PageHeaderProps) {
  useDocumentTitle(title);

  return (
    <header className="sl-page-header">
      <div>
        <h1>{title}</h1>
        {subtitle ? <p className="sl-page-subtitle">{subtitle}</p> : null}
      </div>
      {children ? <div className="d-flex gap-2 align-items-center">{children}</div> : null}
    </header>
  );
}

export default PageHeader;
